import { Component, OnInit } from '@angular/core';
import {DataService} from '../../services/data.service';

@Component({
  selector: 'app-playboy',
  templateUrl: './playboy.component.html',
  styleUrls: ['./playboy.component.css']
})
export class PlayboyComponent implements OnInit {

  postsData:any[];
  posts:Post[];
  myHTML;
  showRowImages:boolean[];
  showRowVideos:boolean[];

  showColumnImages:boolean[];
  showColumnVideos:boolean[];

  lastVideoViewed:any;



  constructor(private dataService:DataService) { }

  ngOnInit() {
    this.dataService.getPosts("playboy").subscribe((post)=>{
      console.log(post);
      this.posts=post;
      this.postsData = this.posts;
    });

    this.showRowImages=[true,true,true,true,true,true];
    this.showRowVideos=[false,false,false,false,false,false];
    this.showColumnImages=[true,true,true];
    this.showColumnVideos=[false,false,false];
    this.lastVideoViewed="";

  }



    onItemClick(theRow,theColumn) {
      // Begin: reset the images
      this.showRowImages=[true,true,true,true,true,true];
      this.showRowVideos=[false,false,false,false,false,false];

      this.showColumnImages=[true,true,true];
      this.showColumnVideos=[false,false,false];
      // End: reset the images

      if(this.lastVideoViewed==theRow+" "+theColumn) return;
      this.lastVideoViewed=theRow+" "+theColumn;
      this.showRowVideos[theRow]= true;
      this.showColumnVideos[theColumn]= true;

    }






}



interface Post {

}


// WEBPACK FOOTER //
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/components/playboy/playboy.component.ts